import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconBank: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 13.4999H13.8333V12.6666C13.8333 11.9466 13.386 11.4999 12.6667 11.4999H12.5V7.83323H12.6667C13.386 7.83323 13.8333 7.38656 13.8333 6.66656V4.96051C13.8333 4.51584 13.586 4.11588 13.188 3.91721L8.67065 1.65859C8.24999 1.44925 7.74868 1.44925 7.32935 1.65859L2.81201 3.91721C2.41401 4.11588 2.16667 4.51584 2.16667 4.96051V6.66656C2.16667 7.38656 2.614 7.83323 3.33333 7.83323H3.5V11.4999H3.33333C2.614 11.4999 2.16667 11.9466 2.16667 12.6666V13.4999H2C1.724 13.4999 1.5 13.7239 1.5 13.9999C1.5 14.2759 1.724 14.4999 2 14.4999H14C14.276 14.4999 14.5 14.2759 14.5 13.9999C14.5 13.7239 14.276 13.4999 14 13.4999ZM11.5 11.4999H9.83333V7.83323H11.5V11.4999ZM7.16667 11.4999V7.83323H8.83333V11.4999H7.16667ZM3.18937 6.81516C3.18871 6.81516 3.18871 6.81516 3.18937 6.81516C3.18604 6.80983 3.16667 6.77056 3.16667 6.66656V4.96051C3.16667 4.89717 3.20196 4.83992 3.25863 4.81126L7.77596 2.55263C7.91796 2.48196 8.08204 2.48196 8.22404 2.55263L12.7414 4.81126C12.798 4.83926 12.8333 4.89651 12.8333 4.96051V6.66656C12.8333 6.77056 12.814 6.80926 12.8153 6.81126C12.81 6.81392 12.7707 6.83323 12.6667 6.83323H3.33333C3.23267 6.83323 3.19271 6.81516 3.18937 6.81516ZM4.5 7.83323H6.16667V11.4999H4.5V7.83323ZM3.16667 12.6666C3.16667 12.5626 3.18599 12.5239 3.18465 12.5219C3.18999 12.5192 3.22933 12.4999 3.33333 12.4999H12.6667C12.788 12.4999 12.812 12.518 12.8114 12.518C12.814 12.524 12.8333 12.5626 12.8333 12.6666V13.4999H3.16667V12.6666ZM7.16667 4.66656C7.16667 4.20656 7.54 3.83323 8 3.83323C8.46 3.83323 8.83333 4.20656 8.83333 4.66656C8.83333 5.12656 8.46 5.4999 8 5.4999C7.54 5.4999 7.16667 5.12656 7.16667 4.66656Z"
      fill={color}
    />
  </svg>
);

export default IconBank;
